import { aiWidgetAliases } from 'components/AiAnalytics/shared/aiWidgetActions';
import { hasRenderableWidgetData } from 'components/AiAnalytics/shared/aiWidgetGuards';
import { FrictionSignalsFrequencyApiResponse } from 'components/AiAnalytics/shared/aiWidgetResponse.types';
import { FrictionSignalsView } from './FrictionSignals.types';

const colors = ['#8a3ffc', '#168f86', '#f5a623', '#174866', '#d64545', '#6f7d86'];
const formatLabel = (label: string) => label.replace(/_/g, ' ');

export const mapFrictionSignalsResponse = (response: unknown): FrictionSignalsView | null => {
  if (!hasRenderableWidgetData(aiWidgetAliases.FRICTION_SIGNALS, response)) return null;
  const { data } = response as FrictionSignalsFrequencyApiResponse;
  return {
    totalSessions: data.total_sessions,
    items: data.items.map((item, index) => ({
      id: `${index}-${item.label}`,
      label: formatLabel(item.label),
      count: item.count,
      percent: item.pct,
      color: colors[index % colors.length],
    })),
  };
};
